module.exports = __webpack_public_path__ + "static/media/img-faq.570f8af7.jpg";